import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { PermissionRouteGuard } from '@/hooks/usePermissions'
import { OrderDetail } from '@/components/features/orders/OrderDetail'
import styles from '@/pages/Orders.module.css'

export const Route = createFileRoute('/_authenticated/orders_/$orderId')({
  component: OrderDetailGuard,
})

function OrderDetailGuard() {
  return (
    <PermissionRouteGuard resource="orders" action="read">
      <OrderDetailPage />
    </PermissionRouteGuard>
  )
}

function OrderDetailPage() {
  const { orderId } = Route.useParams()
  const navigate = useNavigate()

  return (
    <div className={styles.page}>
      <button
        type="button"
        className={styles.backButton}
        onClick={() => navigate({ to: '/orders' })}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M19 12H5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M12 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        Back to Orders
      </button>
      <OrderDetail orderId={orderId} />
    </div>
  )
}
